export const ROUTES = {
  // Auth routes (public, relative - prefix with / when navigating)
  AUTH: "auth",
  SIGN_UP: "sign-up",
  SIGN_IN: "login",
  SIGN_OUT: "logout",
  PASSWORD: "password",
  FORGOT_PASSWORD: "forgot-password",
  RESET_PASSWORD: "reset-password",
  REGISTER: "register",
  SELECT_TENANT: "select-tenant",

  // Protected routes (relative paths, used under /:tenant)
  ONBOARDING: "onboarding",

  ROOT: "/",
  PROJECTS: "projects",
  PROJECT: "project",
  FORMS: "forms",
  PROJECT_CREATION: "project/new",
  FEE: "fee",

  PROJECT_OVERVIEW: "overview",
  PROJECT_MEMBERS: "members",
  PROJECT_PARTICIPANTS: "participants",
  PROJECT_DOCUMENTS: "documents",
  PROJECT_FILES: "files",
  PROJECT_FORMS: "forms",
  PROJECT_PAYMENTS: "payments",
  PROJECT_SCHEDULING: "scheduling",
  PROJECT_ACTIVITY_LOGS: "activityLogs",
  PROJECT_DISCUSSIONS: "discussions",

  TENANTS: "tenants",
  TENANT: "tenant",

  PARTNERS_LENDERS: "partners/lenders",
  PARTNERS_CONTRACTING_COMPANIES: "partners/contracting-companies",

  USERS: "users",
  USERS_DASHBOARD: "users/dashboard",
  USERS_ADMINS: "users/admins",
  USERS_PROJECT_MANAGERS: "users/project-managers",
  USERS_LOAN_OFFICERS: "users/loan-officers",
  USERS_LOAN_PROCESSORS: "users/loan-processors",
  USERS_CLIENTS: "users/clients",
  CLIENT_PROPERTIES: "clients/:id/properties",
  USERS_CONTRACTORS: "users/contractors",
  USERS_INSPECTORS: "users/inspectors",

  PROPERTIES: "properties",
  CALENDAR: "calendar",
  SETTINGS: "settings",
  SETTINGS_PROFILE: "profile",
  SETTINGS_PASSWORD: "password",

  PROFILE: "profile",

  LEGAL: "legal",
  COOKIE_NOTICE: "cookie-notice",
  PRIVACY_POLICY: "privacy-policy",
};
